export default "__VITE_ASSET__ec6d0ba6__"